import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimaryTwo = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimaryTwo.palette['--sui-palette-background-primary'] = '13 80 46';

export { WinterHoliday2026PrimaryTwo };